import { Box, Button, IconButton, Tooltip } from "@mui/material";
import React from "react";

interface ToolbarButtonProps {
  id: string;
  title: string;
  onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  color: string;
  marginLeft?: number;
  children?: React.ReactNode;
  textLabel?: string;
  active?: boolean;
  disabled?: boolean;
}

export function ToolbarButton(props: ToolbarButtonProps) {
  const { id, title, onClick, color, marginLeft = 0, children, textLabel, active, disabled, ...rest } = props;

  const backgroundColor = active ? "#006DD9" : "#49494D";
  const hoverBackgroundColor = "#808386";

  return (
    <Box id={id}>
      {textLabel ? (
        <Button
          onClick={onClick}
          disabled={disabled}
          sx={{
            marginLeft: `${marginLeft}rem`,
            color,
            backgroundColor,
            "&:hover": {
              backgroundColor: hoverBackgroundColor,
            },
          }}
        >
          {textLabel}
        </Button>
      ) : (
        <Tooltip title={title}>
            <span>
              <IconButton
                {...rest}
                disabled={disabled}
                onClick={onClick}
                sx={{
                  marginLeft: `${marginLeft}rem`,
                  color,
                  backgroundColor,
                  "&:hover": {
                    backgroundColor: hoverBackgroundColor,
                  },

                  "&.Mui-disabled": {
                    backgroundColor: "#808386",
                    color: "#E5E9ED",
                  },
                }}
              >
                {children}
              </IconButton>
            </span>
        </Tooltip>
      )}
    </Box>
  );
}
